import React from 'react';
import { useTranslation } from 'react-i18next';

import { Card, CardHeader, CardTitle, CardContent } from '../ui';

export interface InfoItem {
  text: string;
  subItems?: string[];
}

interface ToolInfoPanelProps {
  title?: string;
  items: InfoItem[];
  className?: string;
}

export const ToolInfoPanel: React.FC<ToolInfoPanelProps> = ({
  title,
  items,
  className = '',
}) => {
  const { t } = useTranslation();

  const displayTitle = title || t('tools.info.title');

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle className="text-lg sm:text-xl">{displayTitle}</CardTitle>
      </CardHeader>
      <CardContent className="text-xs sm:text-sm text-gray-600">
        <ul className="space-y-2 list-disc list-inside">
          {items.map((item, index) => (
            <li key={index}>
              {item.text}
              {item.subItems && item.subItems.length > 0 && (
                <ul className="ml-4 mt-1 space-y-1 list-disc list-inside text-xs">
                  {item.subItems.map((subItem, subIndex) => (
                    <li key={subIndex}>{subItem}</li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
